import debounce from 'lodash-es/debounce';
import Base from '../base';

class PatternsValidator extends Base {
	start() {
		const { fieldSelector } = this.options;

		if (!fieldSelector) {
			console.warn('A field selector mandatory');

			return;
		}

		const field = this.query(fieldSelector, document.body);

		if (!field) {
			console.warn(`Could not find an element for selector "${fieldSelector}"`);

			return;
		}

		this.patterns = this.queryAll('[data-option-pattern]').map(el => ({
			el,
			pattern: el.dataset.optionPattern,
			regexp: new RegExp(el.dataset.optionPattern),
			isValid: false,
		}));

		this.onInput = debounce(this.onInput, 250);
		this.on('input', field);
	}

	onInput(e) {
		this.patterns.forEach((pattern) => {
			const { regexp, el } = pattern;
			const isValid = regexp.exec(e.target.value) !== null;

			el.classList.toggle('is-valid', isValid);

			pattern.isValid = isValid;
		});
	}
}

export default PatternsValidator;
